// src/pages/servicos/cadastros/TipoEquipamentoSearch.js
import React, { useEffect, useMemo, useRef, useState } from 'react';

import { FaSortDown, FaSortUp } from 'react-icons/fa';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import ModalTable from '../../../components/modalForm/ModalTable';
import LazyLoading from '../../../components/modalForm/LazyLoading';
import { useTipoEquipamento } from '../../../contexts/servicos/TipoEquipamentoContext';
import ModalSearchBar from '../../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../../components/modalForm/ModalActions';
import ModalSelectButton from '../../../components/modalForm/ModalSelectButton';

const TipoEquipamentoSearch = ({ show, onHide, onSelectTipoEquipamento }) => {
  const { tiposEquipamento } = useTipoEquipamento();
  const [filtro, setFiltro] = useState('');

  const [ordenacao, setOrdenacao] = useState({ campo: 'id', direcao: 'asc' });
  const inputRef = useRef(null);

  useEffect(() => {
    if (show) {
      setFiltro('');

      setTimeout(() => inputRef.current?.focus(), 0);
    }
  }, [show]);

  const tiposFiltrados = useMemo(() => {
    const texto = filtro.trim().toLocaleLowerCase('pt-BR');
    const filtrados = texto
      ? tiposEquipamento.filter(tipo => [tipo.id, tipo.descricao]
        .some(valor => String(valor || '').toLocaleLowerCase('pt-BR').includes(texto)))
      : tiposEquipamento;

    return [...filtrados].sort((a, b) => {
      const comparacao = ordenacao.campo === 'id'
        ? Number(a.id) - Number(b.id)
        : String(a.descricao || '').localeCompare(String(b.descricao || ''), 'pt-BR');
      return ordenacao.direcao === 'asc' ? comparacao : -comparacao;
    });
  }, [tiposEquipamento, filtro, ordenacao]);

  if (!show) return null;

  const ordenar = campo => setOrdenacao(anterior => ({
    campo,
    direcao: anterior.campo === campo && anterior.direcao === 'asc' ? 'desc' : 'asc',
  }));

  const iconeOrdenacao = campo => ordenacao.campo === campo
    ? (ordenacao.direcao === 'asc' ? <FaSortUp /> : <FaSortDown />)
    : null;

  const selecionar = tipo => {
    onSelectTipoEquipamento(tipo);
    onHide();
  };

  return (
    <ModalContainer show={show} zIndex={1060} variant="busca" onHide={onHide}>
      <ModalHeader title="Buscar Tipo de Equipamento" onHide={onHide} />
      <ModalBody>
        <div className="mb-3">
          <ModalSearchBar
            inputRef={inputRef}
            type="text"

            placeholder="Filtrar por código ou descrição..."
            value={filtro}
            onChange={e => {
              setFiltro(e.target.value);

            }}
          />
        </div>
        <LazyLoading items={tiposFiltrados} resetKey={JSON.stringify([show, filtro, ordenacao])}>
        {({ containerRef, handleScroll, visibleItems }) => (
        <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
          <thead>
            <tr>
              <th className="text-center" style={{ width: '20%' }} aria-sort={ordenacao.campo === 'id' ? (ordenacao.direcao === 'asc' ? 'ascending' : 'descending') : 'none'}>
                <button type="button" onClick={() => ordenar('id')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0}>
                  Código {iconeOrdenacao('id')}
                </button>
              </th>
              <th className="text-start" style={{ width: '50%' }} aria-sort={ordenacao.campo === 'descricao' ? (ordenacao.direcao === 'asc' ? 'ascending' : 'descending') : 'none'}>
                <button type="button" onClick={() => ordenar('descricao')} style={{ fontWeight: 'bold', background: 'none', border: 'none' }} tabIndex={0}>
                  Descrição {iconeOrdenacao('descricao')}
                </button>
              </th>
              <th className="text-center" style={{ width: '15%' }}>Situação</th>
              <th className="text-center modal-select-column" style={{ width: '15%' }}>Selecionar</th>
            </tr>
          </thead>
          <tbody>
            {visibleItems.map(tipo => (
              <tr key={tipo.id} onDoubleClick={() => selecionar(tipo)}>
                <td className="text-end">{tipo.id}</td>
                <td>{tipo.descricao}</td>
                <td className="text-center">{tipo.ativo ? 'Ativo' : 'Inativo'}</td>
                <td className="text-center modal-select-column">
                  <ModalSelectButton type="button" className="btn btn-outline-secondary btn-sm" onClick={() => selecionar(tipo)} label={tipo.descricao} />
                </td>
              </tr>
            ))}
            {visibleItems.length === 0 && (
              <tr><td colSpan="4" className="text-center text-muted">Nenhum tipo de equipamento encontrado.</td></tr>
            )}
          </tbody>
        </ModalTable>
        )}
        </LazyLoading>
      </ModalBody>
      <ModalFooter>

        <ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">Fechar</ModalActionButton>
      </ModalFooter>
    </ModalContainer>
  );
};

export default TipoEquipamentoSearch;
